<template>
    <div v-if="( dados || ( lista && autoriz ) ) && ( !id_procedimento || exibicao.length )">
        <p class="mb-0" v-if="!lista">Histórico</p>
        <div class="alert alert-info mb-1 py-1 px-3 d-flex justify-content-between" v-if="ver_inativos || ( exibicao && !exibicao.length )">
            <div>Nenhum pacote {{ ativos ? 'ativo' : 'registrado' }}</div>
            <div class="custom-control custom-switch" v-if="ativos">
                <input type="checkbox" class="custom-control-input" 
                    id="ativo-pacote" 
                    v-model="ver_inativos">
                <label class="custom-control-label" for="ativo-pacote">Histórico</label>
            </div>
        </div>
        <div class="card" v-for="(pacote, idx) in exibicao" :key="idx" :class="lista ? 'mb-0' : ''">
            <div class="card-header d-flex justify-content-between" :class="( reduzido ? 'p-1 small' : '' ) + classe_do_atendimento(pacote)">
                <div>
                    <i class="fas fa-layer-group mr-2 text-primary"></i>
                    <a class="card-link" href="#" @click.prevent="ver_detalhes_pacote(pacote)"> <!-- ver_detalhes = !ver_detalhes -->
                        <span v-if="pacote.pacote && pacote.pacote.procedimento && pacote.pacote.fl_combo">
                            {{ pacote.pacote.procedimento.st_procedimento }}
                        </span>
                        <span v-else-if="pacote.procedimento">
                            {{ pacote.procedimento.search }}
                        </span>
                        <span v-else>
                            {{ pacote.procedimento_pacote.procedimento.search }}
                        </span>
                    </a>
                    <span class="ml-3 badge badge-secondary" v-if="pacote.st_regiao">{{ pacote.st_regiao }}</span>
                    <span class="ml-3 text-muted" v-if="lista_senhas(pacote)">{{ lista_senhas(pacote) }}</span>

                    <span class="ml-3 badge badge-secondary" v-if="pacote.id_atendimento_pacote">{{ pacote.id_atendimento_pacote }}</span>

                    <template v-if="pacote.unidade_operacao && pacote.unidade_operacao.st_sigla">
                        <span class="ml-3 badge badge-light" :title="pacote.unidade_operacao.st_nome">
                            {{ pacote.unidade_operacao.st_sigla }}
                        </span>
                    </template>

                    <div class="small text-muted" v-if="pacote.atendimento && pacote.atendimento.plano && !reduzido">
                        <span v-if="pacote.validade" title="Validade.">
                            <i class="fas fa-less-than-equal"></i>
                            {{ $util.getFormatDate(pacote.validade) }}
                            <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                        </span>
                        {{ pacote.atendimento.plano.search }}
                        
                    </div>
                </div>
                <div v-if="(pacote.pacote && pacote.pacote.procedimento && pacote.pacote.fl_combo)">
                    <div class="text-right">
                        #{{ pacote.atendimento.id_atendimento }}
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        {{ $util.getFormatDate(pacote.atendimento.dt_inicio) }}
                    </div>
                    <div class="text-right" v-if="pacote.faltantes">
                        <span :class="pacote.faltantes.length ? 'badge badge-danger' : 'badge badge-success'" class="mr-2" title="Execução do Pacote.">
                            {{ pacote.faltantes.length }}
                        </span>

                        <button type="button" class="btn btn-sm btn-link my-0 py-0" data-toggle="tooltip" data-placement="top" 
                            :title="pacote.fl_encerrado ? 'Clique para reabrir' : 'Clique para encerrar'"
                            @click="toggle_abertura_pacote(pacote)"
                            :disabled="$store.state.loading">
                            <i class="fas fa-door-open" v-if="!pacote.fl_encerrado"></i>
                            <i class="fas fa-door-closed" v-else></i>
                        </button>
                    </div>
                </div>
                <div v-else class="text-right">
                    <!-- !reduzido &&  -->
                    <span v-if="( !reduzido || !pode_fechar ) && ( numero_sessoes(pacote) < ( pacote.in_quantidade_items ? pacote.in_quantidade_items : pacote.procedimento_pacote.in_quantidade ) )">
                        <button type="button" class="btn btn-sm btn-link my-0 py-0" data-toggle="tooltip" data-placement="top" 
                            :title="pacote.fl_encerrado ? 'Clique para reabrir' : 'Clique para encerrar'"
                            @click="toggle_abertura_pacote(pacote)"
                            :disabled="$store.state.loading">
                            <i class="fas fa-door-open" v-if="!pacote.fl_encerrado"></i>
                            <i class="fas fa-door-closed" v-else></i>
                        </button>
                    </span>

                    <span v-if="pacote.in_sessoes_previas" title="Sessões prévias realizadas em outro local.">{{ pacote.in_sessoes_previas }} +</span>

                    {{ numero_sessoes(pacote) }}/{{ pacote.in_quantidade_items ? pacote.in_quantidade_items : pacote.procedimento_pacote.in_quantidade }}
                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                    #{{ pacote.atendimento.id_atendimento }}
                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                    {{ $util.getFormatDate(pacote.atendimento.dt_inicio) }}
                    <div v-if="pacote.fl_encerrado && pacote.st_motivo" class="text-truncate text-right small text-muted" style="max-width: 300px">
                        <a href="#" @click.prevent="ler_motivo(pacote)" class="card-link">
                            {{ pacote.st_motivo }}
                        </a>
                    </div>
                    <div v-if="pacote.st_obs" class="text-truncate text-right small text-muted" style="max-width: 300px">
                        Obs: {{ pacote.st_obs }}
                    </div>
                </div>
            </div>
            <div v-show="!pacote.id_unidade">
                <div class="card-body d-flex justify-content-between alert-secondary py-2" v-if="pacote.guia_datas && pacote.guia_datas.length">
                    <div class="small">
                        Datas: {{ pacote.guia_datas.map(item => $util.getFormatDate(item) + ( ( item && item.length > 10 ) ? ' ' + item.slice(11,16) : '' )).join(', ') }}
                    </div>
                    <div class="small">
                        {{ pacote.guia_datas.length }}
                        
                        <a href="#" @click.prevent="definir_datas(pacote)" class="ml-3" title="Definir datas igual a dos atendimentos." v-if="pacote.atendimento_procedimentos && pacote.atendimento_procedimentos.length">
                            <i class="fa-solid fa-rotate"></i>
                        </a>
                    </div>
                </div>
                <ul class="list-group" v-if="pacote.atendimento_procedimentos && pacote.atendimento_procedimentos.length">
                    <li class="list-group-item d-flex justify-content-between hover-bg"  v-for="(atp, iax) in ordenado(pacote.atendimento_procedimentos)" :key="iax" :class="( id_atendimento && atp.id_atendimento == id_atendimento ) ? 'list-group-item-success' : ''">
                        <div>
                            <!-- Símbolo da Marcação -->
                            <template>
                                <span v-if="atp.atendimento.marcacao && atp.atendimento.marcacao.fl_extra" class="mr-2">
                                    <i class="fas fa-exclamation-circle" title="Extra"></i>
                                </span>

                                <span v-else-if="atp.atendimento.marcacao && atp.atendimento.marcacao.fl_adicao_direta" class="mr-2">
                                    <i class="fas fa-plus-circle" title="Demanda Espontânea"></i>
                                </span>

                                <span v-else class="mr-2">
                                    <i class="fas fa-dot-circle" title="Marcado"></i>
                                </span>
                            </template>
        
                            <span v-if="!(pacote.pacote && pacote.pacote.procedimento && pacote.pacote.fl_combo)">
                                {{ atp.numero_sessao }}/{{ atp.total_sessao }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            </span>

                            <a href="#" @click.prevent="abrir_atendimento(atp.id_atendimento)" class="card-link">
                                #{{ atp.id_atendimento }}
                            </a>

                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            <span title="Data do Atendimento" :class=" ( atp.dt_execucao && atp.dt_execucao.slice(0,10) != atp.atendimento.dt_inicio.slice(0,10) ) ? 'text-muted' : '' ">
                                {{ $util.getFormatDate(atp.atendimento.dt_inicio) }}
                            </span>

                            <template v-if="atp.dt_execucao && atp.dt_execucao.slice(0,10) != atp.atendimento.dt_inicio.slice(0,10)">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                <span title="Data Informada">
                                    {{ $util.getFormatDate(atp.dt_execucao) }}
                                </span>
                            </template>

                            <!-- Alerta de Data fora da Lista -->
                            <template v-if="pacote.atendimento 
                                && pacote.guia_datas
                                && pacote.guia_datas.length 
                                && !check_data(atp, pacote.guia_datas)">
                                <span title="Data divergente da lista.">
                                    <i class="fa fa-exclamation-triangle text-danger ml-2" aria-hidden="true"></i>
                                </span>
                            </template>

                            <template v-if="pacote.pacote && pacote.pacote.procedimento && pacote.pacote.fl_combo">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ atp.procedimento.search }}
                            </template>
                            <template v-if="atp.st_codigo_autorizacao">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                <span class="text-muted">
                                    Senha: 
                                    {{ atp.st_codigo_autorizacao }}
                                </span>
                            </template>

                            <!-- Profissional -->
                            <template v-if="atp.atendimento && atp.atendimento.medico">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                <span class="text-muted" title="Profissional">
                                    {{ atp.atendimento.medico.st_nome_exibicao }}
                                </span>
                            </template>

                            <!-- Unidade -->
                            <template v-if="atp.atendimento && atp.atendimento.marcacao && atp.atendimento.marcacao.unidade_operacao && atp.atendimento.marcacao.unidade_operacao.st_sigla">
                                <span class="ml-3 badge badge-light" :title="atp.atendimento.marcacao.unidade_operacao.st_nome">
                                    {{ atp.atendimento.marcacao.unidade_operacao.st_sigla }}
                                </span>
                            </template>

                            <!-- Guia -->
                            <template v-if="atp.atendimento_procedimento_guia && atp.atendimento_procedimento_guia.guia">
                                <span class="ml-3 badge" :class="'badge-' + atp.atendimento_procedimento_guia.guia.status_color" :title="atp.atendimento_procedimento_guia.guia.status_guia + ': ' + atp.atendimento_procedimento_guia.guia.id_guia">
                                    {{ atp.atendimento_procedimento_guia.guia.ch_status }}
                                </span>
                            </template>
                        </div>
                        <div class="text-right">
                            <span v-if="atp.in_quantidade > 1" class="badge badge-secondary" title="Quantidade">
                                x{{ atp.in_quantidade }}
                            </span>

                            <span v-if="atp.id_atendimento == pacote.id_atendimento && !atp.ind_transf && !atp.ind_alter_qt">
                                <i class="fa-solid fa-circle-play ml-4"></i>
                            </span>

                            <template v-if="pode_transferir && id_atendimento && atp.id_atendimento != id_atendimento && !atp.ind_transf && !atp.ind_alter_qt && pacote.pacote && pacote.pacote.fl_cobranca_total">
                                <a href="#" @click.prevent="transferir_selecao(atp)" title="Transferir para outro pacote" class="ml-4">
                                    <i class="fa-solid fa-arrow-right-arrow-left"></i>
                                </a>
                            </template>
                            
                            <template v-if="pode_transferir && id_atendimento && atp.id_atendimento != id_atendimento && !atp.ind_transf && !atp.ind_alter_qt && pacote.pacote && pacote.pacote.fl_cobranca_total">
                                <a href="#" @click.prevent="atp.novo_qtd = atp.in_quantidade; atp.ind_alter_qt = !atp.ind_alter_qt;" class="ml-4" title="Alterar quantidade">
                                    <i class="fa-solid fa-plus-minus"></i>
                                </a>
                            </template>

                            <!-- Alterar Quantidade -->
                            <div class="input-group input-group-sm mb-0" v-else-if="atp.ind_alter_qt">
                                <input class="form-control form-sm" v-model="atp.novo_qtd" :disabled="$store.state.loading" type="number" min="1" max="9999" />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-danger btn-sm" @click.prevent="atp.ind_alter_qt = false" :disabled="$store.state.loading">
                                        <i class="fa-solid fa-xmark fa-fw"></i>
                                    </button>
                                    <button class="btn btn-outline-success btn-sm" @click.prevent="atualizar_quantidade(atp)" v-if="atp.novo_qtd" :disabled="$store.state.loading">
                                        <i class="fa-solid fa-check fa-fw"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- Transferir Para -->
                            <div class="input-group input-group-sm mb-0" v-else-if="atp.ind_transf">
                                <select class="form-control form-sm" v-model="atp.transf_para" :disabled="$store.state.loading">
                                    <option value="">Transferir para...</option>
                                    <option v-for="(item, iix) in lista_candidatos(pacote, atp)" :key="iix" :value="item.id_atendimento_pacote">
                                        {{ item.id_atendimento_pacote }} 
                                        / 
                                        {{ numero_sessoes(item) }}/{{ item.in_quantidade_items ? item.in_quantidade_items : item.procedimento_pacote.in_quantidade }}
                                        /
                                        #{{ item.atendimento.id_atendimento }}
                                        /
                                        {{ $util.getFormatDate(item.atendimento.dt_inicio) }}
                                    </option>
                                </select>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-danger btn-sm" @click.prevent="transferir_selecao(atp)" :disabled="$store.state.loading">
                                        <i class="fa-solid fa-xmark fa-fw"></i>
                                    </button>
                                    <button class="btn btn-outline-success btn-sm" @click.prevent="transferir_atualizar(atp)" v-if="atp.transf_para" :disabled="$store.state.loading">
                                        <i class="fa-solid fa-check fa-fw"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </li>

                    <!-- Faltantes do Pacote -->
                    <template v-if="pacote.faltantes && pacote.faltantes.length">
                        <li class="list-group-item d-flex justify-content-between hover-bg list-group-item-danger"  v-for="(falta, ifx) in pacote.faltantes" :key="'F' + ifx">
                            <div>
                                <i class="fa-solid fa-circle fa-fw mr-2"></i>
                                <span v-if="falta.procedimento">{{ falta.procedimento.search }}</span>
                            </div>
                            <div>
                                <span class="badge badge-danger">{{ falta.in_quantidade - falta.in_realizada }}/{{ falta.in_quantidade }}</span>
                            </div>
                        </li>
                    </template>
                </ul>

                <pre v-if="false">{{ pacote }}</pre>
            </div>
        </div>

        <!-- Modal Motivo Encerramento -->
        <div class="modal fade" :id="'motivoEncerraPacoteModal' + sufixo_modal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="pacote_selecionado">
                    <div class="modal-header">
                        <h5 class="modal-title">Motivo</h5>
                        <button type="button" class="close" @click="fechar_modal('motivoEncerraPacoteModal' + sufixo_modal)" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input   
                            label="Motivo"
                            type="textarea"
                            required
                            :validate="validate"
                            v-model="motivo" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('motivoEncerraPacoteModal' + sufixo_modal)">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="toggle_abertura_pacote(pacote_selecionado, motivo)">Encerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Ler Motivo Modal -->
        <div class="modal fade" :id="'lerMotivoModal' + sufixo_modal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="pacote_selecionado">
                    <div class="modal-header">
                        <h5 class="modal-title">Motivo</h5>
                        <button type="button" class="close" @click="fechar_modal('lerMotivoModal' + sufixo_modal)" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div style="white-space: pre-wrap;">{{ pacote_selecionado.st_motivo }}</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('lerMotivoModal' + sufixo_modal)">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            dados: null, 
            validate: false, 
            motivo: "", 
            ver_inativos: false, 
            ver_detalhes: false,
            pacote_selecionado: null, 
            sufixo_modal: "", 
            id_paciente: null, 
        }
    },

    components: { 
        AzInput
    }, 

    props: ['lista', 'ativos', 'autoriz', 'id_procedimento', 'reduzido', 'pode_fechar', 'id_atendimento', 'pode_transferir'],

    computed: { 
        exibicao: function () { 
            if ( this.autoriz && this.lista ) { 

                if ( this.ativos && !this.ver_inativos ) { 
                    return this.lista.filter(pacote => !pacote.fl_encerrado
                        && this.numero_sessoes(pacote) < ( pacote.in_quantidade_items ? pacote.in_quantidade_items : pacote.procedimento_pacote.in_quantidade ) );
                }

                return this.lista;

            }

            if ( !this.dados ) 
                return [];

            /*
            <span v-if="pacote.pacote && pacote.pacote.procedimento && pacote.pacote.fl_combo">
                {{ pacote.pacote.procedimento.st_procedimento }}
            </span>
            <span v-else-if="pacote.procedimento">
                {{ pacote.procedimento.search }}
            </span>
            <span v-else>
                {{ pacote.procedimento_pacote.procedimento.search }}
            </span>
            */

            if ( this.ativos && !this.ver_inativos ) { 
                return this.dados.filter(pacote => !pacote.fl_encerrado
                    && ( !this.id_procedimento || _.get(pacote, 'procedimento_pacote.id_procedimento') == this.id_procedimento )
                    && this.numero_sessoes(pacote) < ( pacote.in_quantidade_items ? pacote.in_quantidade_items : pacote.procedimento_pacote.in_quantidade ) );
            }

            return this.dados;
        }
    },

    methods: { 
        ordenado(lista) { 
            return _.orderBy(lista, atp => atp.dt_execucao ? atp.dt_execucao : ( atp.atendimento ? atp.atendimento.dt_inicio : '' ), 'asc');
        },
        
        atualizar_quantidade (atp) { 
            this.$util.atualizar(this, { 
                service: 'atendimento_pacotes',
                func: 'atualizar_pacote_qtd',
                dados: { 
                    id_atendimento_procedimento: atp.id_atendimento_procedimento,
                    novo_qtd: atp.novo_qtd,
                },
                callback: () => { 
                    this.abrir(this.id_paciente);
                }
            });
        },

        transferir_atualizar(atp) { 
            if ( atp.atendimento_procedimento_guia ) { 
                if ( !confirm('Confirma a transferência do procedimento, com o cancelamento da guia atual?') ) { 
                    return;
                }
            }

            this.$util.atualizar(this, { 
                service: 'atendimento_pacotes',
                func: 'transferir_atp',
                dados: { 
                    id_atendimento_pacote: atp.id_atendimento_pacote,
                    id_atendimento_procedimento: atp.id_atendimento_procedimento,
                    id_atendimento_pacote_destino: atp.transf_para,
                },
                callback: () => { 
                    this.abrir(this.id_paciente);
                }
            });
        },

        transferir_selecao(atp) { 
            atp.transf_para = "";
            atp.ind_transf = !atp.ind_transf;
            
            this.$forceUpdate();
        },

        lista_candidatos(pacote, atp) { 
            return this.exibicao.filter(item => { 
                return item.id_atendimento_pacote != pacote.id_atendimento_pacote
                    && item.id_procedimento == pacote.id_procedimento
                    && item.atendimento.dt_inicio.slice(0,10) <= atp.atendimento.dt_inicio.slice(0,10);
            });
        },

        definir_datas (pacote) { 
            if ( this.$store.state.loading ) { 
                return;
            }
            
            if ( !confirm("Confirma alterar a lista de datas para a lista de datas de atendimentos?") ) { 
                return;
            }

            let datas = pacote.atendimento_procedimentos.map(atp => atp.dt_execucao ? atp.dt_execucao.slice(0,10) : atp.atendimento.dt_inicio.slice(0,10));
            
            this.$util.atualizar(this, { 
                service: 'atendimentos', 
                func: 'set_guia_datas', 
                dados: { 
                    id_atendimento: pacote.atendimento.id_atendimento, 
                    id_guia: pacote.guia_com_datas, 
                    datas: datas, 
                },
                toast: true,
                callback: () => {
                    pacote.guia_datas = _.uniq(datas);
                }
            });
        },

        check_data (atp, datas) { 

            let data = atp.dt_execucao ? atp.dt_execucao.slice(0,10) : atp.atendimento.dt_inicio.slice(0,10);

            if ( !datas.find(item => item && item.slice(0,10) == data) ) { 
                return false;
            }

            return true; 

        },

        abrir_atendimento(id_atendimento) { 
            $('.modal').modal('hide');
            this.$util.abrir_atendimento(this, id_atendimento);
        },

        classe_do_atendimento(pacote) { 
            if ( !this.id_atendimento ) { 
                return '';
            }

            if ( pacote.atendimento_procedimentos && pacote.atendimento_procedimentos.length ) { 
                if ( pacote.atendimento_procedimentos.some(atp => atp.id_atendimento == this.id_atendimento) ) { 
                    return ' alert-success';
                }
            }

            return '';
        },

        ver_detalhes_pacote(pacote) { 
            if ( !pacote.atendimento_procedimentos ) { 
                this.$util.loadItem(this, { 
                    service: 'atendimento_pacotes',
                    func: 'show',
                    parms: { 
                        id: pacote.id_atendimento_pacote, 
                        detalhe: true, 
                    },
                })
                .then(res => { 
                    pacote.atendimento_procedimentos = res.atendimento_procedimentos;
                    pacote.id_unidade = !pacote.id_unidade;

                    this.$forceUpdate();
                });
                
            } else { 
                pacote.id_unidade = !pacote.id_unidade;
                this.$forceUpdate();
            }
        },

        fechar_modal(nome) { 
            $('#' + nome).modal('hide');
        },

        ler_motivo (pacote) { 
            this.pacote_selecionado = pacote;

            $('#lerMotivoModal' + this.sufixo_modal).modal('show');
        },

        lista_senhas(pacote) { 
            if ( !pacote.atendimento_procedimentos ) { 
                return '';
            }

            return _.uniq(
                    pacote.atendimento_procedimentos.filter(item => item.st_codigo_autorizacao)
                        .map(item => item.st_codigo_autorizacao)
                )
                .join(', ');
        },

        numero_sessoes(pacote) { 
            if ( pacote.atendimento_procedimentos_count ) { 
                return pacote.atendimento_procedimentos_count;
            }

            if ( !pacote.atendimento_procedimentos ) { 
                return 0;
            }

            return pacote.atendimento_procedimentos.reduce((total, carry) => { 
                return total + parseInt(carry.in_quantidade);
            }, 0);
        },

        toggle_abertura_pacote(pacote, motivo = null) {
            if ( this.pode_transferir === false ) { 
                return;
            }
            
            this.pacote_selecionado = _.cloneDeep(pacote); 

            if ( pacote && !pacote.fl_encerrado && !motivo ) { 
                
                this.motivo = this.pacote_selecionado.st_motivo;
                this.validate = false;

                $('#motivoEncerraPacoteModal' + this.sufixo_modal).modal('show');

                return;

            }

            this.$util.atualizar(this, { 
                service: 'atendimento_pacotes',
                func: 'toggle_pacote_encerrar',
                dados: { 
                    id_atendimento_pacote: pacote.id_atendimento_pacote, 
                    motivo: motivo,  
                },
                callback: () => { 
                    this.abrir(pacote.id_paciente);
                },
                modal: 'motivoEncerraPacoteModal' + this.sufixo_modal, 
            });
        },

        abrir(id_paciente) { 
            this.dados = null; 
            this.id_paciente = id_paciente;

            this.$util.load(this, { 
                service: 'atendimento_pacotes',
                func: 'index',
                parms: { 
                    id_paciente: id_paciente, 
                },
                loadTo: res => { 
                    this.dados = res.map(item => { 
                        if ( item.atendimento_procedimentos && item.atendimento_procedimentos.length ) { 
                            item.atendimento_procedimentos.forEach(atp => { 
                                atp.transf_para = '';
                                atp.ind_transf = false;
                                atp.ind_alter_qt = false;
                                atp.novo_qtd = 1; 
                            });
                        }
                        return item;
                    });
                }
            });
        },

        reset() {
            this.dados = null;
        }
    },

    mounted() { 
        this.dados = this.lista;
        this.sufixo_modal = this.$util.uuidv4();
    }
}
</script>